/**
 * Module dependencies.
 */

import { Disclosure, Type } from 'src/components/core';
import { ReactElement, ReactNode, useState } from 'react';
import { color, units } from '@untile/react-components';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  children: ReactNode;
  className?: string;
  measure?: string;
  title: string;
};

/**
 * `Header` styled component.
 */

const Header = styled.div`
  display: grid;
  grid-gap: ${units(1)};
  grid-template-columns: repeat(2, max-content);
  width: 100%;
`;

/**
 * `Content` styled component.
 */

const Content = styled.div`
  padding: 0 ${units(4)} ${units(3)};
  position: relative;
`;

/**
 * `MeasureLabel` styled component.
 */

const MeasureLabel = styled(Type.Paragraph).attrs({ as: 'span' })`
  color: ${color('grey400')};
`;

/**
 * `BaseDisclosure` component.
 */

const BaseDisclosure = (props: Props): ReactElement => {
  const { children, className, measure, title } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <Disclosure
      className={className}
      header={
        <Header>
          <Type.Paragraph as={'span'}>{title}</Type.Paragraph>

          {measure && <MeasureLabel>{measure}</MeasureLabel>}
        </Header>
      }
      isOpen={isOpen}
      toggle={() => setIsOpen(!isOpen)}
    >
      <Content>{children}</Content>
    </Disclosure>
  );
};

/**
 * Export `BaseDisclosure` component.
 */

export default BaseDisclosure;
